export default class Register {
    constructor() {
        this.personRequest = {};
        this.contactRequest = {};
        this.addressRequest = {};
        this.userRequest = {};
        this.planRequest = {};
    }
}